module.exports = __webpack_public_path__ + "static/media/parcours.db02d6c6.jpg";